export default "__VITE_ASSET__Cilmd7eh__"